import React from 'react';
import { string } from 'prop-types';

import Alert from '../alert';
import Loading from '../loading';
import { getCardComponent } from './cards';

function List({
  emailAriaLabel,
  errorDescription,
  errorHeading,
  loadingDataLabel,
  resultListing,
  resultText,
  error,
  isLoading,
  phoneAriaLabel,
  resultsAriaLabel,
  externalLinkText,
  resourceTypesLabel,
  eligibilityLabel,
  ageGroupsLabel,
  partnersLabel
}) {
  if (isLoading) return <Loading label={loadingDataLabel} />;

  if (error)
    return (
      <Alert
        heading={errorHeading}
        description={errorDescription}
        type="error"
      />
    );

  return (
    resultListing?.length > 0 && (
      <section className="staff-list" aria-label={resultsAriaLabel}>
        <p className="staff-list__description">{resultText}</p>
        <div className="staff-list__list">
          {resultListing.map(({ Type, Id, ...attributes }) =>
            getCardComponent(
              Type,
              attributes,
              Id,
              emailAriaLabel,
              phoneAriaLabel,
              externalLinkText,
              resourceTypesLabel,
              eligibilityLabel,
              ageGroupsLabel,
              partnersLabel
            )
          )}
        </div>
      </section>
    )
  );
}

List.propTypes = {
  emailAriaLabel: string,
  errorDescription: string.isRequired,
  errorHeading: string.isRequired,
  fetchUrl: string.isRequired,
  loadingDataLabel: string.isRequired,
  phoneAriaLabel: string,
  resultsAriaLabel: string.isRequired,
  externalLinkText: string,
  resourceTypesLabel: string,
  eligibilityLabel: string,
  ageGroupsLabel: string,
  partnersLabel: string
};

export default React.memo(List);
